// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3NjUm","rootSuccess":"CompleteLink_rootSuccess__315gg","rootFailure":"CompleteLink_rootFailure__nyDQN","isDisabled":"CompleteLink_isDisabled__1MlPw"};